import { Component, Input } from '@angular/core';
import { ModalBaseComponent } from '../modal-base.component';

@Component({
  selector: 'app-changes-confirmation-component',
  templateUrl: './changes-confirmation.component.html'
})
export class ChangesConfirmationComponent extends ModalBaseComponent<boolean> {
  @Input() title: string;
  @Input() description: string;
  @Input() confirmText = 'YES, CONFIRM!';

  confirm() {
    this.submit(true);
  }
}
